import { render, staticRenderFns } from "./Contactperson.vue?vue&type=template&id=1da525f0&scoped=true&"
import script from "./Contactperson.vue?vue&type=script&lang=js&"
export * from "./Contactperson.vue?vue&type=script&lang=js&"
import style0 from "./Contactperson.vue?vue&type=style&index=0&id=1da525f0&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1da525f0",
  null
  
)

export default component.exports